// Wstęgi z hasłami: jadą w kółko, przy przewijaniu przyspieszają i zmieniają kierunek razem ze scrollem; najechanie myszką je zatrzymuje.
import {gsap, ScrollTrigger, $$} from "./shared";

export function initMarquees() {
    $$("[data-cc-marquee]").forEach((ribbon) => {
        const track = ribbon.querySelector(".cc-marquee__track");
        if (!track) {
            return;
        }
        ribbon.classList.add("is-js");
        const base = ribbon.dataset.dir === "right" ? -1 : 1;
        const seconds = parseFloat(getComputedStyle(ribbon).getPropertyValue("--speed")) || 30;
        const loop = gsap.fromTo(track, {xPercent: 0}, {xPercent: -50, duration: seconds, ease: "none", repeat: -1});
        loop.totalTime(seconds * 500).timeScale(base); // zapas czasu, żeby można było jechać też do tyłu

        let hover = false;
        let dir = 1;
        const settle = () => gsap.to(loop, {timeScale: hover ? 0 : base * dir, duration: 1.2, ease: "power2.out", overwrite: true});

        ScrollTrigger.create({
            trigger: ribbon,
            start: "top bottom",
            end: "bottom top",
            onToggle: (self) => (self.isActive ? loop.resume() : loop.pause()),
            onUpdate: (self) => {
                dir = self.direction;
                if (hover) {
                    return;
                }
                const boost = 1 + Math.min(Math.abs(self.getVelocity()) / 250, 5);
                gsap.to(loop, {timeScale: base * dir * boost, duration: 0.25, overwrite: true, onComplete: settle});
            }
        });

        ribbon.addEventListener("pointerenter", () => {
            hover = true;
            settle();
        });
        ribbon.addEventListener("pointerleave", () => {
            hover = false;
            settle();
        });
    });
}
